import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Collapse } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { ThemeProvider } from 'styled-components';
import { getAntdThemeConfig } from '../../../utils/antdTheme';
import { ConfigProvider } from 'antd';
import {
  Container,
  Title,
  ReportsGrid,
  ReportCard,
  CardContent,
  CardHeader,
  IconWrapper,
  CardText,
  CardTitle,
  CardSubtitle,
  ArrowIcon,
  StyledCollapse,
  DetailCard,
  DetailTitle,
  DetailDescription,
} from './Styles';
import { REPORT_CARDS, ICONS, DETAIL_MESSAGES } from './constants';
import { ReportType } from './types';

const MerchantReports: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();
  const theme = { mode: isDarkMode ? 'dark' : 'light' } as const;
  const antdTheme = getAntdThemeConfig(isDarkMode);
  const [selectedItem, setSelectedItem] = useState<ReportType | null>(null);

  const handleClick = (item: ReportType, route?: string) => {
    if (route) {
      navigate(route);
    } else {
      setSelectedItem(item === selectedItem ? null : item);
    }
  };

  const renderDetails = (itemId: ReportType) => {
    if (selectedItem !== itemId) return null;
    
    const details = DETAIL_MESSAGES[itemId];
    if (!details) return null;

    return (
      <StyledCollapse
        activeKey={['details']}
        ghost
      >
        <Collapse.Panel key="details" header="">
          <DetailCard>
            <DetailTitle level={4}>{details.title}</DetailTitle>
            <DetailDescription>{details.description}</DetailDescription>
          </DetailCard>
        </Collapse.Panel>
      </StyledCollapse>
    );
  };

  return (
    <ConfigProvider theme={antdTheme}>
      <ThemeProvider theme={theme}>
        <Container>
          <Title level={1}>Reports</Title>

          <ReportsGrid>
            {REPORT_CARDS.map((card) => (
              <ReportCard
                key={card.id}
                $isSelected={selectedItem === card.id}
                onClick={() => handleClick(card.id, 'route' in card ? card.route : undefined)}
              >
                <CardContent>
                  <CardHeader>
                    <CardText>
                      <CardTitle level={4}>{card.title}</CardTitle>
                      <CardSubtitle>{card.subtitle}</CardSubtitle>
                    </CardText>
                    <IconWrapper>
                      <FontAwesomeIcon icon={card.icon} />
                    </IconWrapper>
                  </CardHeader>
                  {'hasDetails' in card && card.hasDetails && (
                    <ArrowIcon icon={ICONS.arrowRight} />
                  )}
                </CardContent>
              </ReportCard>
            ))}
          </ReportsGrid>
          
          {REPORT_CARDS.filter(card => 'hasDetails' in card && card.hasDetails).map((card) => (
            renderDetails(card.id)
          ))}
        </Container>
      </ThemeProvider>
    </ConfigProvider>
  );
};

export default MerchantReports;
